import './resources'

import { josa } from 'es-hangul'
import { type ParseKeys, t } from 'i18next'

/**
 * 번역 결과에 한국어 조사를 붙여 반환한다. `lng: 'custom'` 한국어 한 언어 고정 전제의 함수다.
 * 등록된 brand 키는 자동완성되지만, 팩에 없는 문자열도 그대로 통과시킨다 (미등록 키는 i18next 가 key 를 반환).
 */
export const tJosa = (
  key: ParseKeys | (string & Record<never, never>),
  josaOption?: Parameters<typeof josa>[1],
): string => {
  const translated = t(key as ParseKeys)
  return josaOption ? josa(translated, josaOption) : translated
}
